const main = function(v,vueInstanct){ return vueInstanct.$emit('updateAvatarTitle',v); };
module.exports = main;